import { AfterViewInit, Component } from '@angular/core';
import { Chart } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom'
Chart.plugins.register({ zoomPlugin });

@Component({
  selector: 'homepage-chart',
  templateUrl: 'homepage-chart.html',
  inputs: ['chartInputData']
})
export class HomepageChartComponent implements AfterViewInit {

  chartInputData: any;
  charts: any = [];

  constructor() {
  }

  ngAfterViewInit(): void {
    console.log(this.chartInputData);
    for (let i = 0; i < this.chartInputData.length; i++) {
      let chart = this.chartInputData[i];
      let chartType = chart.type;
      let chartData = chart.data;
      let chartXTitle = chart.xAxisTitle;
      let chartYTitle = chart.yAxisTitle;
      let ctx = <HTMLCanvasElement>document.getElementById('myChart_' + i);
      ctx.height = 100;
      let myChart = new Chart(ctx, {
        type: chartType,
        data: chartData,
        options: {
          maintainAspectRatio: false,
          scales: chartXTitle == undefined && chartYTitle == undefined ? undefined : {
            xAxes: [{
              scaleLabel: {
                display: chartXTitle != undefined,
                labelString: chartXTitle
              }
            }],
            yAxes: [{
              scaleLabel: {
                display: chartYTitle != undefined,
                labelString: chartYTitle
              }
            }]
          },
          plugins: chartType != 'line' ? {} : {
            zoom: {
              zoom: {
                enabled: true,
                mode: 'xy'
              },
              pan: {
                enabled: true
              }
            }
          }
        }
      });
      this.charts.push(myChart);
    }
  }

  downloadChart(index) {
    let base64 = this.charts[index].toBase64Image('image/png', 1)
    let a = document.createElement("a");
    a.href = base64;
    a.download = "chart.png";
    a.click();
  }

}



// WEBPACK FOOTER //
// ./src/components/homepage-chart/homepage-chart.ts